export default __webpack_public_path__ + "static/media/single-line-blackboard-high.ed47eece.jpg";